<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-confirm-modal-list">
      <h3>Deseja evadir o paciente? Ele sairá da fila de atendimento.</h3>
    </div>
    <form class="form" [formGroup]="model"  (ngSubmit)="submit()">
      <div class="body-confirm-modal-list">
        <div class="row">
          <div class="col-12">
            <mat-radio-group aria-label="" formControlName="idEvasionNotes" class="radio-group">
              @for (item of listEvasionNotesModel; track item) {
                <mat-radio-button value="{{item.idEvasionNotes}}"
                  (change)="onRadioButtonChange(item)">{{item.description}}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
          @if (isOthersEvasionButtonSelected) {
            <div class="col-md-12">
              <mat-form-field appearance="outline">
                <mat-label>Notas de evasão</mat-label>
                <textarea matInput formControlName="conclusionNote"></textarea>
                @if (model.get('conclusionNote').invalid) {
                  <mat-error>Informe a nota de evasão!</mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
      </div>
      <div class="footer-confirm-modal-list">
        <button mat-flat-button color="primary" class="btn-block" type="submit">
          @if (isLoading == false) {
            <span>Sim, evadir</span>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
        <button mat-flat-button color="accent" class="btn-block"(click)="clickCancel()" type="button">
          @if (isLoading == false) {
            <span>Cancelar</span>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
      </div>
    </form>
  </div>
</div>